export type ColorModePreference = "light" | "dark" | "system";
export type ResolvedColorMode = "light" | "dark";

export const COLOR_MODE_STORAGE_KEY = "webapp2.accessibility.colorMode";

export function isColorModePreference(value: unknown): value is ColorModePreference {
    return value === "light" || value === "dark" || value === "system";
}

export function loadStoredColorMode(): ColorModePreference {
    try {
        const raw = localStorage.getItem(COLOR_MODE_STORAGE_KEY);
        if (isColorModePreference(raw)) return raw;
    } catch {
        /* ignore */
    }
    return "dark";
}

export function persistColorMode(mode: ColorModePreference): void {
    try {
        localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode);
    } catch {
        /* ignore */
    }
}

export function resolveColorMode(preference: ColorModePreference): ResolvedColorMode {
    if (preference === "system") {
        if (typeof window !== "undefined" && window.matchMedia) {
            return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
        }
        return "dark";
    }
    return preference;
}

/** Apply resolved theme to <html> for CSS variable switching. */
export function applyResolvedColorMode(resolved: ResolvedColorMode): void {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", resolved);
    document.documentElement.style.colorScheme = resolved;
}
